import { z } from "zod";

const BrowseItemWatchlistSchema = z
  .object({
    search: z.string(),
    query: z.any(),
    sort: z.array(z.object({ property: z.string(), asc: z.boolean() })),
    page: z.number().min(1, { message: "Page is out of bounds" }),
    pageSize: z
      .number()
      .min(1, { message: "Page is out of bounds" })
      .max(100, { message: "Page is out of bounds" })
      .default(25),
  })
  .strict();

export default BrowseItemWatchlistSchema;
